<template>
  <div>
    <el-dialog
      title="Nhiệm vụ"
      :visible.sync="dialogMissionVisible"
      :close-on-click-modal="false"
      width="960px"
      @closed="onCloseMissionDialog"
    >
      <!-- <div class="content-container"> -->
      <div class="content-box">
        <div class="section-box">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-group-title">Thông tin đoàn</div>
              <InfoList
                :columns="3"
                :column-breakpoint-options="{
                  sm: 1,
                  md: 3
                }"
              >
                <!-- <InfoListLabel style="max-width: 300px">Lorem ipsum</InfoListLabel>

          <InfoListValue style="max-width: 300px"
            >Lorem ipsum dolor sit amet consectetur adipisicing elit.
            Exercitationem eligendi magni expedita, deleniti reiciendis nihil
            corrupti molestiae ad iusto eaque?</InfoListValue
          > -->

                <InfoListLabel>Mã đoàn</InfoListLabel>
                <InfoListValue
                  >{{ groupMasterData.booking_code }}
                </InfoListValue>

                <InfoListLabel>Ngày đến</InfoListLabel>
                <InfoListValue>{{
                  groupMasterData.first_arrival_date
                }}</InfoListValue>

                <InfoListLabel>Ngày đi</InfoListLabel>
                <InfoListValue>{{
                  groupMasterData.last_departure_date
                }}</InfoListValue>

                <InfoListLabel>Công ty, đại lý du lịch</InfoListLabel>
                <InfoListValue>{{ groupMasterData.agent_name }}</InfoListValue>
              </InfoList>
              <!-- <div class="das-form-row">
                <div class="das-form-col w-33">
                  <div class="das-form-input">
                    <div class="label">Mã đoàn</div>
                    <div class="child-w-80">
                      <input
                        v-model="groupMasterData.booking_code"
                        type="text"
                        readonly
                      />
                    </div>
                  </div>
                </div>
                <div class="das-form-col w-33">
                  <div class="das-form-input">
                    <div class="label">Ngày đến</div>
                    <div class="child-w-80">
                      <input
                        v-model="groupMasterData.first_arrival_date"
                        type="text"
                        readonly
                      />
                    </div>
                  </div>
                </div>
                <div class="das-form-col w-33">
                  <div class="das-form-input">
                    <div class="label">Công ty, đại lý du lịch</div>
                    <div class="child-w-80">
                      <input
                        v-model="groupMasterData.agent_name"
                        type="text"
                        readonly
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="das-form-row">
                <div class="das-form-col w-33">
                  <div class="das-form-input">
                    <div class="label">Ngày đi</div>
                    <div class="child-w-80">
                      <input
                        v-model="groupMasterData.last_departure_date"
                        type="text"
                        readonly
                      />
                    </div>
                  </div>
                </div>
              </div> -->
              <!-- <div class="das-form-col w-33">
                  <div class="das-form-input">
                    <div class="label">Số phòng</div>
                    <div class="child-w-80">
                      <input type="text" readonly />
                    </div>
                  </div>
                </div> -->
            </div>
            <div class="das-form-group">
              <div class="das-form-group-title">Danh sách nhiệm vụ</div>
              <div v-loading="missionTableLoading" style="height: 300px">
                <GridVx
                  ref="missionTable"
                  :columns="missionColumns"
                  :rows="missionRows"
                  dom-layout="scroll"
                  class="agGrid"
                  @selectionChanged="onSelectedMission"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <!-- <div class="button-containers-outline"> -->
          <button
            class="btn primary small outline"
            :disabled="
              selectedMission === null ||
              selectedMission?.completion_time === null ||
              selectedMission?.cancel_time !== null
            "
            @click="cancelSuccessfulMission"
          >
            Hủy hoàn thành
          </button>
          <button
            class="btn primary small outline"
            :disabled="
              selectedMission === null || selectedMission?.cancel_time !== null
            "
            @click="cancelMission"
          >
            Hủy nhiệm vụ
          </button>
          <button
            class="btn primary small outline"
            :disabled="
              selectedMission === null ||
              selectedMission?.cancel_time !== null ||
              selectedMission?.completion_time !== null
            "
            @click="openUpdateMission"
          >
            Sửa nhiệm vụ
          </button>
          <!-- </div> -->
          <!-- <div class="button-containers-primary"> -->
          <button
            class="btn primary small"
            @click="dialogAddMissionVisible = true"
          >
            Thêm nhiệm vụ
          </button>
          <button
            class="btn primary small"
            :disabled="
              selectedMission === null ||
              selectedMission?.completion_time !== null ||
              selectedMission?.cancel_time !== null
            "
            @click="updateToSuccessfulMission"
          >
            Hoàn thành
          </button>
          <!-- </div> -->
        </div>
        <div class="button-containers close-btn">
          <button
            class="btn primary small outline"
            @click="dialogMissionVisible = false"
          >
            Đóng
          </button>
        </div>
      </span>
    </el-dialog>

    <!-- Add Mission Dialog -->
    <el-dialog
      title="Thêm nhiệm vụ"
      :visible.sync="dialogAddMissionVisible"
      :close-on-click-modal="false"
      width="720px"
    >
      <!-- <div class="content-container"> -->
      <div class="das-form-container" style="height: 370px">
        <div class="das-form-group">
          <div class="das-form-group-title">
            {{ $t('field.missionInfo') }}
          </div>
          <validation-observer ref="addMissionFormValidator">
            <div class="das-form-row">
              <div class="das-form-col w-50">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.implementDate') }}
                  </div>
                  <validation-provider
                    rules="required"
                    :name="$t('field.implementDate')"
                    vid="missionForm.implementDate"
                  >
                    <div class="child-w-80">
                      <!-- <SingleCalendar
                            v-model="missionForm.implementDate"
                            class="use-icon"
                            :date-data="missionForm.implementDate"
                          /> -->
                      <!-- style="display: block" -->
                      <CalendarRange v-model="execDate" mode="date" />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col w-25">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.implementTime') }}
                  </div>
                  <validation-provider
                    rules="required"
                    :name="$t('field.implementTime')"
                    vid="missionForm.implementTime"
                  >
                    <div class="child-w-80">
                      <!-- <el-time-picker
                            v-model="missionForm.exe_time"
                            placeholder="Time"
                            value-format="HH:mm:ss"
                          /> -->
                      <TimePicker
                        v-model="missionForm.exe_time"
                        format="HH:mm:ss"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col w-50">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.department') }}
                  </div>
                  <validation-provider
                    rules="required"
                    :name="$t('field.department')"
                    vid="missionForm.department"
                  >
                    <div class="child-w-80">
                      <el-select
                        v-model="missionForm.department_ids"
                        multiple
                        collapse-tags
                        placeholder="Vui lòng chọn"
                      >
                        <el-option
                          v-for="item in departmentList"
                          :key="`customer-title-${item.id}`"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>

            <div class="das-form-row">
              <div class="das-form-col w-50">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.content') }}
                  </div>
                  <validation-provider
                    rules="required"
                    :name="$t('field.content')"
                    vid="missionForm.content"
                  >
                    <textarea
                      v-model="missionForm.content"
                      :rows="7"
                      style="width: 100%"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
          </validation-observer>
        </div>
      </div>
      <!-- </div> -->
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="fnAddMission">Lưu</button>
          <button
            class="btn primary small outline"
            @click="dialogAddMissionVisible = false"
          >
            Hủy
          </button>
        </div>
      </span>
    </el-dialog>

    <!-- Update Mission Dialog -->
    <el-dialog
      v-if="selectedMission"
      title="Sửa nhiệm vụ"
      :visible.sync="dialogUpdateMissionVisible"
      :close-on-click-modal="false"
      width="720px"
    >
      <!-- <div class="content-container"> -->
      <div class="content-box">
        <div class="section-box">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-group-title">
                {{ $t('field.missionInfo') }}
              </div>
              <validation-observer ref="updateMissionFormValidator">
                <div class="das-form-row">
                  <div class="das-form-col w-50">
                    <div class="das-form-input">
                      <div class="label required">
                        {{ $t('field.department') }}
                      </div>
                      <validation-provider
                        rules="required"
                        :name="$t('field.department')"
                        vid="selectedMission.department"
                      >
                        <div class="child-w-80">
                          <!-- <Multiselect
                            v-model="selectedMission.department"
                            :disabled="true"
                            :options="departmentList"
                            :multiple="true"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :preserve-search="true"
                            placeholder="Chọn"
                            label="name"
                            track-by="id"
                            :preselect-first="true"
                            ><template
                              slot="selection"
                              slot-scope="{ values, search, isOpen }"
                              ><span
                                v-if="values.length"
                                v-show="!isOpen"
                                class="multiselect__single"
                                ><span
                                  v-for="(item, index) in values"
                                  :key="index"
                                >
                                  {{ item.name
                                  }}<span v-if="index !== values.length - 1">
                                    ,
                                  </span>
                                </span></span
                              ></template
                            ></Multiselect
                          > -->
                          <input
                            v-model="selectedMission.department_name"
                            disabled
                            type="text"
                          />
                        </div>
                      </validation-provider>
                    </div>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col w-22">
                    <div class="das-form-input">
                      <div class="label required">
                        {{ $t('field.implementDate') }}
                      </div>
                      <validation-provider
                        rules="required"
                        :name="$t('field.implementDate')"
                        vid="selectedMission.implement_date"
                      >
                        <div class="child-w-80">
                          <CalendarSelect
                            v-model="selectedMission.impl_date"
                            style="display: block"
                            mode="date"
                          />
                        </div>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="das-form-col w-25">
                    <div class="das-form-input">
                      <div class="label required">
                        {{ $t('field.implementTime') }}
                      </div>
                      <validation-provider
                        rules="required"
                        :name="$t('field.implementTime')"
                        vid="selectedMission.exec_time"
                      >
                        <div class="child-w-80">
                          <!-- <el-time-picker
                            v-model="selectedMission.exec_time"
                            value-format="HH:mm:ss"
                            placeholder="Time"
                          /> -->
                          <TimePicker
                            v-model="selectedMission.exec_time"
                            format="HH:mm:ss"
                          />
                        </div>
                      </validation-provider>
                    </div>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col w-50">
                    <div class="das-form-input">
                      <div class="label required">
                        {{ $t('field.content') }}
                      </div>
                      <validation-provider
                        rules="required"
                        :name="$t('field.content')"
                        vid="selectedMission.content"
                      >
                        <textarea
                          v-model="selectedMission.content"
                          style="width: 100%"
                        />
                      </validation-provider>
                    </div>
                  </div>
                </div>
              </validation-observer>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="fnUpdateMission">
            Lưu
          </button>
          <button
            class="btn primary small outline"
            @click="dialogUpdateMissionVisible = false"
          >
            Hủy
          </button>
        </div>
      </span>
    </el-dialog>

    <!-- Successful Mission Dialog -->
    <el-dialog
      title="Hoàn thành"
      :visible.sync="dialogSuccessfulMissionVisible"
      :close-on-click-modal="false"
      width="720px"
    >
      <!-- <div class="content-container"> -->
      <div class="content-box">
        <div class="section-box">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-group-title">
                {{ $t('field.missionInfo') }}
              </div>
              <validation-observer ref="successMissionFormValidator">
                <div class="das-form-row">
                  <div class="das-form-col w-50">
                    <div class="das-form-input">
                      <div class="label required">
                        {{ $t('field.note') }}
                      </div>
                      <div class="child-w-80">
                        <validation-provider
                          rules="required"
                          :name="$t('field.note')"
                          vid="successNote"
                        >
                          <textarea v-model="successNote" style="width: 100%" />
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                </div>
              </validation-observer>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="fnSuccessfulMission">
            Xác nhận
          </button>
          <button
            class="btn primary small outline"
            @click="dialogSuccessfulMissionVisible = false"
          >
            Hủy
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import moment from 'moment'
import {
  getDepartmentApi,
  addMissionApi,
  updateMissionApi,
  successfulMissionApi,
  cancelSuccessfulMissionApi,
  cancelMissionApi
} from '@/api/booking_service/bookingGroup'
import { getBookingGroupListApi } from '@/api/booking_service/missionBookingGroupApi'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import Multiselect from 'vue-multiselect'
export default {
  components: {
    CalendarSelect,
    Multiselect,
    CalendarRange
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    selectedData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      execKey: 100,
      successNote: null,

      missionForm: {
        content: '',
        booking_group_id: 0,
        sub_booking_group_id: null,
        start_date: '',
        end_date: '',
        exe_time: this.$moment().startOf('day').format('HH:mm:ss'),
        department_ids: []
      },
      missionDefaultForm: {
        content: '',
        booking_group_id: 0,
        sub_booking_group_id: null,
        start_date: '',
        end_date: '',
        exe_time: this.$moment().startOf('day').format('HH:mm:ss'),
        department_ids: []
      },
      selectedMission: null,

      dialogMissionVisible: false,
      dialogAddMissionVisible: false,
      dialogUpdateMissionVisible: false,
      dialogSuccessfulMissionVisible: false,

      departmentList: [],
      missionColumns: [
        {
          headerName: 'STT',
          field: 'no',
          minWidth: 60,
          maxWidth: 60,
          tooltipField: 'no'
        },
        {
          headerName: 'Bộ phận',
          field: 'department_name',
          minWidth: 100,
          tooltipField: 'department_name'
        },
        {
          headerName: 'Trạng thái',
          field: 'status',
          minWidth: 100,
          maxWidth: 130,
          tooltipField: 'status',
          valueGetter: params => {
            if (params.data.status == 1) {
              return 'Đã hoàn thành'
            } else if (params.data.status == 2) {
              return 'Đã hủy'
            } else if (params.data.status == 0) {
              return 'Chưa hoàn thành'
            }
          }
        },
        {
          headerName: 'Nội dung',
          field: 'content',
          minWidth: 100,
          tooltipField: 'fee'
        },
        {
          headerName: 'Thời gian thực hiện',
          headerTooltip: 'Thời gian thực hiện',
          field: 'exe_time',
          minWidth: 120,
          maxWidth: 180,
          cellRenderer: params => {
            return moment(params.value).format('YYYY-MM-DD HH:mm:ss')
          },
          tooltipValueGetter: params => {
            return params.value
              ? this.$moment(params.value).format('YYYY-MM-DD HH:mm:ss')
              : null
          }
        },
        {
          headerName: 'Người thực hiện',
          headerTooltip: 'Người thực hiện',
          field: 'implement_name',
          minWidth: 100,
          maxWidth: 150,
          tooltipField: 'implement_name'
        },
        {
          headerName: 'Thời gian hoàn thành',
          headerTooltip: 'Thời gian hoàn thành',
          field: 'completion_time',
          minWidth: 120,
          maxWidth: 180,
          cellRenderer: params => {
            return params.value
              ? moment(params.value).format('YYYY-MM-DD HH:mm:ss')
              : ''
          },
          tooltipValueGetter: params => {
            return params.value
              ? this.$moment(params.value).format('YYYY-MM-DD HH:mm:ss')
              : null
          }
        },
        {
          headerName: 'Người tạo',
          field: 'create_user_name',
          minWidth: 100,
          maxWidth: 150,
          tooltipField: 'create_user_name'
        },
        {
          headerName: 'Thời gian tạo',
          headerTooltip: 'Thời gian tạo',
          field: 'create_date',
          minWidth: 120,
          maxWidth: 180,
          cellRenderer: params => {
            return params.value
              ? moment(params.value).format('YYYY-MM-DD HH:mm:ss')
              : ''
          },
          tooltipValueGetter: params => {
            return params.value
              ? this.$moment(params.value).format('YYYY-MM-DD HH:mm:ss')
              : null
          }
        },
        {
          headerName: 'Người hủy',
          field: 'cancel_user_name',
          minWidth: 100,
          maxWidth: 150,
          tooltipField: 'cancel_user_name'
        },
        {
          headerName: 'Thời gian hủy',
          headerTooltip: 'Thời gian hủy',
          field: 'cancel_time',
          minWidth: 120,
          maxWidth: 180,
          cellRenderer: params => {
            return params.value
              ? moment(params.value).format('YYYY-MM-DD HH:mm:ss')
              : ''
          },
          tooltipValueGetter: params => {
            return params.value
              ? this.$moment(params.value).format('YYYY-MM-DD HH:mm:ss')
              : null
          }
        },
        {
          headerName: 'Ghi chú',
          field: 'note',
          tooltipField: 'note'
        }
      ],
      missionRows: [],

      missionTableLoading: false,

      groupMasterData: {
        no: null,
        id: null,
        name: null,
        note: null,
        status: null,
        create_date: null,
        create_user_id: null,
        external_id: null,
        booking_code: null,
        confirm_code: null,
        first_arrival_date: null,
        last_departure_date: null,
        agent_id: null,
        agent_name: null,
        user_create: null,
        status_code: null
      }
    }
  },
  // mounted() {
  computed: {
    execDate: {
      get() {
        return {
          start: this.missionForm.start_date,
          end: this.missionForm.end_date
        }
      },
      set(newValue) {
        this.missionForm.start_date = newValue.start
        this.missionForm.end_date = newValue.end
      }
    },
    execDateComputed() {
      return this.selectedMission?.exec_time
    }
  },
  watch: {
    dialogVisible: {
      immediate: true,
      handler(val) {
        this.dialogMissionVisible = this.dialogVisible
        if (val) {
          this.fnGetMissionList()
          this.fnGetDepartment()
        }
      }
    },
    selectedData: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.groupMasterData = this.selectedData
        }
      }
    },
    execDateComputed() {
      this.execKey = this.execKey + 1
    }
  },
  // },
  methods: {
    // execTimeChange() {
    //   console.log('haha')
    //   this.execKey = this.execKey + 1
    // },
    // DATA
    async fnGetMissionList() {
      this.missionTableLoading = true
      getBookingGroupListApi({ bookingGroupId: this.selectedData.id })
        .then(res => {
          this.missionRows = res.data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.missionTableLoading = false
        })
    },
    async fnGetDepartment() {
      this.missionTableLoading = true
      await getDepartmentApi()
        .then(res => {
          this.departmentList = res.data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.missionTableLoading = false
        })
    },

    onSelectedMission(selectMission) {
      this.selectedMission = Object.assign({}, selectMission[0])
      const dateTime = moment(this.selectedMission.exe_time)
      this.selectedMission.impl_date = dateTime.format('YYYY-MM-DD')
      this.selectedMission.exec_time = dateTime.format('HH:mm:ss')
    },

    async fnAddMission() {
      this.missionForm.booking_group_id = this.selectedData.id
      // call api
      if (
        (await this.$vxForm.isValid(this.$refs.addMissionFormValidator)) ===
        false
      ) {
        return
      }
      // alert('add mission!!')
      await addMissionApi(this.missionForm)
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Thêm nhiệm vụ thành công'
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.missionForm = Object.assign({}, this.missionDefaultForm)
          this.dialogAddMissionVisible = false
          this.fnGetMissionList()
        })
    },

    async fnUpdateMission() {
      // call api
      if (
        (await this.$vxForm.isValid(this.$refs.updateMissionFormValidator)) ===
        false
      ) {
        return
      }

      var params = {
        id: this.selectedMission.id,
        content: this.selectedMission.content,
        mofify_user_id: this.selectedMission.mofify_user_id,
        impl_date: this.selectedMission.impl_date,
        exe_time: this.selectedMission.exec_time
      }
      // alert('update mission!!')
      await updateMissionApi(this.selectedMission.id, params)
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Sửa nhiệm vụ thành công'
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.dialogUpdateMissionVisible = false
          this.fnGetMissionList()
        })
      // this.selectedMission = this.missionDefaultForm
    },

    async fnSuccessfulMission() {
      if (
        (await this.$vxForm.isValid(this.$refs.successMissionFormValidator)) ===
        false
      ) {
        return
      }

      // alert('update mission to successful state!!')
      await successfulMissionApi(this.selectedMission.id, this.successNote)
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Cập nhập hoàn thành nhiệm vụ thành công'
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.successNote = ''
          this.dialogSuccessfulMissionVisible = false
          this.fnGetMissionList()
        })
    },

    openUpdateMission() {
      this.dialogUpdateMissionVisible = true
    },
    updateToSuccessfulMission() {
      this.dialogSuccessfulMissionVisible = true
    },
    async cancelSuccessfulMission() {
      // alert('hủy hoàn thành nhiệm vụ id: ' + this.selectedMission.id)
      await cancelSuccessfulMissionApi(this.selectedMission.id)
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Hủy hoàn thành nhiệm vụ thành công'
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.fnGetMissionList()
        })
    },

    async cancelMission() {
      // alert('hủy nhiệm vụ id: ' + this.selectedMission.id)
      await cancelMissionApi(this.selectedMission.id)
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Hủy nhiệm vụ thành công'
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.fnGetMissionList()
        })
    },

    // DIALOG
    onCloseMissionDialog() {
      this.missionForm = Object.assign({}, this.missionDefaultForm)
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped>
.w-50 {
  width: 50%;
}
.w-33 {
  width: 33%;
}
.w-25 {
  width: 25%;
}
.w-22 {
  width: 22%;
}
.mr-2 {
  margin: 0 10px 0 0;
}

.button-containers-seperate {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 0 20px;
}
.button-containers-outline,
.button-containers-primary {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
}
.close-btn {
  padding-top: 10px;
}
</style>
